import http from "./HttpService";

export function getMessstelleUebersichtEndpoint(anlagenId) {
    return "/messstelle/uebersicht/" + anlagenId;
}

export function getMessstelleEndpoint(messstellenId) {
    return "/messstelle/" + messstellenId;
}

export function getMessstelleHistorieEndpoint(messstellenId) {
    return "/messstelle/" + messstellenId + "/historie/";
}

export function getMessstelleSucheEndpoint(params) {
    return "/messstelle/search" + (params ? "?" + params : "");
}

export function postMessstellenExportEndpointConfiguration(selectedIds) {
    return {
        url: "/messstelle/export/",
        method: "POST",
        data: selectedIds,
        responseType: "blob",
    };
}

export function postMessstellenExportAllEndpointConfiguration(params) {
    return {
        url: "/messstelle/export" + (params ? "?" + params : ""),
        method: "POST",
        responseType: "blob",
    };
}

export function getMessstelleFreigabeAnfordernEndpoint(anlageId) {
    return "/anlage/" + anlageId + "/messstelle/";
}

export function getAktiveMessstellenByBetriebEndpoint(betriebId) {
    return "/betrieb/" + betriebId + "/messstelle/";
}

export function getMessstelleFreigabeSetzenEndpoint(messstellenId) {
    return "/messstelle/" + messstellenId + "/freigabe/";
}

export function putMessstelleEndpoint(messstellenId) {
    return "/messstelle/" + messstellenId;
}

export function getOberflaechenwasserkoerper(hochwert, rechtswert) {
    return "/wasserkoerper?hochwert=" + hochwert + "&rechtswert=" + rechtswert;
}

export function getTeileinzugsgebiet(hochwert, rechtswert) {
    return "/einzugsgebiet?hochwert=" + hochwert + "&rechtswert=" + rechtswert;
}

export function getMessstellenNrSuggestion(messstellentyp, hochwert, rechtswert) {
    return "/messstelle/new-id?hochwert=" + hochwert + "&rechtswert=" + rechtswert + "&typ=" + messstellentyp;
}

export function getMessstellennummerCheckEndpoint(id) {
    return "/messstelle/check-id?id=" + id;
}

export function getAnhangAnforderungenEndpoint(anhangId) {
    return "/anhang-abwv/" + anhangId + "/anforderungen/";
}

export const getPegelOptionenEndpoint = "/pegel/";

export function deleteMessstelleEndpoint(messstellenId) {
    return "/messstelle/" + messstellenId;
}

export function getMessstellenPfad(id) {
    return http.get("/messstelle/" + id + "/messstellenpfad/");
}

export function postWiedervorlageForMessstelleEndpoint(messstellenId) {
    return "/messstelle/" + messstellenId + "/wiedervorlage/";
}

export function getWiedervorlageForMessstellleEndpoint(messstellenId) {
    return "/messstelle/" + messstellenId + "/wiedervorlage/";
}

export function getExportMesswerteImport(jahresberichtId, parameterId) {
    return "/messwert/jahresbericht/"+ jahresberichtId + "/parameter/" + parameterId + "/export-messwerte/";
}

export function getPostImportMesswerte(parameterMesswertId) {
    return "/messwert/" + parameterMesswertId + "/import-messwerte/";
}
